// FILECONTENT_START src/common/components/DataGrid/DetailsGridRow.tsx
import Collapse from "@mui/material/Collapse";
import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { useState } from "react";
import { GridRow, GridRowProps } from "./grid-imports";

const defaultTheme = createTheme();
export const useDetailsStyles = makeStyles(
  theme =>
    createStyles({
      root: {
        "& .MuiDataGrid-virtualScrollerContent": {
          height: "auto!important",
        },
        "& .MuiDataGrid-virtualScrollerRenderZone": {
          position: "relative",
        },
      },
    }),
  { defaultTheme }
);

export interface DetailsGridRowProps extends GridRowProps {
  DetailsComponent?: React.JSXElementConstructor<GridRowProps>;
}

/**
 * Collapsible GridRow Component
 *
 * @param {DetailsGridRowProps} props DetailsGridRowProps
 * @returns {JSX.Element} Collapsible GridRow
 */
export function DetailsGridRow({
  DetailsComponent,
  ...props
}: DetailsGridRowProps) {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const isEditing = !!props.editRowsState[props.rowId];
  return DetailsComponent ? (
    <Collapse
      in={open && !isEditing}
      collapsedSize={props.rowHeight}
      //Set visible when open anim started
      onEnter={() => setVisible(true)}
      //Set unvisible when close animation ended
      onExited={() => setVisible(false)}
    >
      <GridRow {...props} onClick={() => setOpen(!open)} />
      {visible && (
        /* Component to render in panel */
        <DetailsComponent {...props} />
      )}
    </Collapse>
  ) : (
    <GridRow {...props} />
  );
}

// FILECONTENT_END src/common/components/DataGrid/DetailsGridRow.tsx